class DrJayteeProductGallery extends HTMLElement {
  connectedCallback() {
    this.mainImage = this.querySelector('[data-gallery-main-image]');
    this.caption = this.querySelector('[data-gallery-caption]');
    this.thumbnails = [...this.querySelectorAll('[data-gallery-thumbnail]')];
    this.selectionToken = 0;

    if (!this.mainImage || this.thumbnails.length < 2) return;

    this.thumbnails.forEach((thumbnail) => {
      thumbnail.addEventListener('click', () => this.selectThumbnail(thumbnail));
    });
  }

  async selectThumbnail(thumbnail) {
    if (thumbnail.getAttribute('aria-current') === 'true') return;

    const selectionToken = ++this.selectionToken;
    const nextImage = new Image();
    nextImage.srcset = thumbnail.dataset.gallerySrcset || '';
    nextImage.sizes = thumbnail.dataset.gallerySizes || '';
    nextImage.src = thumbnail.dataset.gallerySrc;

    try {
      await nextImage.decode();
    } catch {
      if (!nextImage.complete) return;
    }

    if (selectionToken !== this.selectionToken) return;

    this.mainImage.srcset = thumbnail.dataset.gallerySrcset || '';
    this.mainImage.sizes = thumbnail.dataset.gallerySizes || '';
    this.mainImage.src = thumbnail.dataset.gallerySrc;
    this.mainImage.alt = thumbnail.dataset.galleryAlt || '';
    this.thumbnails.forEach((item) => item.setAttribute('aria-current', String(item === thumbnail)));

    if (this.caption) this.caption.textContent = thumbnail.dataset.galleryCaption || '';
  }
}

if (!customElements.get('drjaytee-product-gallery')) {
  customElements.define('drjaytee-product-gallery', DrJayteeProductGallery);
}
